// extracted by mini-css-extract-plugin
module.exports = {"fieldLable":"RulesOfRulesDetails_fieldLable__1nfaL","alignWidth":"RulesOfRulesDetails_alignWidth__2EC68"};